module.exports = __webpack_public_path__ + "static/media/martin_dominguez.55d5b67d.jpg";